import { HtmlParser } from '@calendly/html-parser'
import { I18n } from '@calendly/i18n'
import { Loader } from '@calendly/ui/components/loader'
import { useSelector } from 'react-redux'

import { paymentMethodSelector, subscriptionProviderSelector } from 'features/billing/selectors'
import {
  ignoreCurrentChargeSelector,
  isUpcomingInvoiceLoadingSelector,
  upcomingInvoiceDataSelector
} from 'features/billing/selectors/upcoming_invoice'


import { LoadingStateContainer, Paragraph, SalesTaxInfo } from './styles'
import { useVatFlagAndCountryEnabled } from '../../../../hooks/feature_flags/use_vat_flag_and_country_enabled'
import {
  billingAddressCountrySelector,
  secondaryTaxIdSelector,
  taxIdSelector
} from '../../stages/paid_stage/billing_information_card/selectors'

export const UpcomingInvoice = ({ strategy }) => {
  const isInvoiceLoading = useSelector(isUpcomingInvoiceLoadingSelector)
  const paymentMethod = useSelector(paymentMethodSelector)
  const invoice = useSelector(upcomingInvoiceDataSelector)
  const provider = useSelector(subscriptionProviderSelector)
  const ignoreCurrentCharge = useSelector(ignoreCurrentChargeSelector)
  const localizationKey = ignoreCurrentCharge
    ? 'will_be_charged_html'
    : 'an_estimated_prorated_charge_html'
  const billingAddressCountry = useSelector(billingAddressCountrySelector)
  const shouldShowVatFlow = useVatFlagAndCountryEnabled(billingAddressCountry)
  const taxId = useSelector(taxIdSelector)
  const secondaryTaxId = useSelector(secondaryTaxIdSelector)

  const renderInvoiceMessage = () => {
    if (shouldShowVatFlow) {
      return (
        <Paragraph>
          <strategy.InvoiceMessage invoice={invoice} />
          {(taxId || secondaryTaxId) && (
            ` (${I18n.t('publisher.billing.change_plan.invoice_message.tax_info_applied')}).`
          )}
        </Paragraph>
      )
    }

    return (
      <Paragraph>
        <strategy.InvoiceMessage invoice={invoice} provider={provider} />
        {strategy.getDisplayAppendSalesTax(invoice) && (
          <SalesTaxInfo>
            {' '}
            {I18n.t('publisher.billing.change_plan.invoice_message.includes_sales_tax')}
          </SalesTaxInfo>
        )}
      </Paragraph>
    )
  }

  if (isInvoiceLoading || !invoice) {
    return (
      <LoadingStateContainer>
        <Loader />
      </LoadingStateContainer>
    )
  }

  // i18n-tasks-use t('publisher.billing.change_plan.invoice_message.upgrade_and_increase_quantity.month_html')
  // i18n-tasks-use t('publisher.billing.change_plan.invoice_message.upgrade_and_increase_quantity.year_html')
  // i18n-tasks-use t('publisher.billing.change_plan.paypal.will_be_charged_html')
  // i18n-tasks-use t('publisher.billing.change_plan.paypal.an_estimated_prorated_charge_html')
  // i18n-tasks-use t('publisher.billing.change_plan.credit_card.will_be_charged_html')
  // i18n-tasks-use t('publisher.billing.change_plan.credit_card.an_estimated_prorated_charge_html')
  return (
    <>
      {renderInvoiceMessage(strategy, invoice)}
      {
        strategy.displayProratedCharge && (
          <Paragraph>
            {HtmlParser(
              I18n.t(`publisher.billing.change_plan.${paymentMethod}.${localizationKey}`, {
                amount: invoice.today_amount_due,
                card_brand: invoice.card_brand,
                card_last4: invoice.card_last4
              })
            )}
          </Paragraph>
        )
      }
    </>
  )
}
